<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6">
        <external-informator
          :partner="partner"
          title="Регион"
          titleKey="region"
          valueKey="regionId"
          labelKey="name"
          v-model="data.regionId"
          :link="'catalog/regions'"
        />
      </div>

      <div class="col-12 col-md-6">
        <external-informator
          :disabled="!data.regionId"
          :partner="partner"
          title="Город / район"
          titleKey="city"
          :staticFilterId="data.regionId"
          staticFilterKey="regionId"
          valueKey="districtCode"
          labelKey="name"
          v-model="data.districtCode"
          :link="'catalog/districts'"
        />
      </div>

      <div class="col-12 col-md-6">
        <external-select
          :data="informers.documentTypes"
          v-model="data.documentType"
        />
      </div>

      <div class="col-12 col-md-6">
        <external-select :data="informers.genderTypes" v-model="data.gender" />
      </div>

      <div class="col-12 col-md-6">
        <external-select
          :data="informers.addressesTypes"
          v-model="data.addressType"
        />
      </div>

      <div class="col-12 col-md-6">
        <fg-input
          :type="`text`"
          :label="`Серия паспорта`"
          :labelKey="`passport_series`"
          v-model="data.passport"
        ></fg-input>
      </div>
      <div class="col-12 col-md-6">
        <fg-input
          :type="`date`"
          :label="`Дата рождения`"
          :labelKey="`birthday`"
          v-model="data.birthday"
        ></fg-input>
      </div>
      <div class="col-12 col-md-6">
        <fg-input
          :type="`date`"
          :label="`Дата выдачи паспрта`"
          :labelKey="`passport_issued_at`"
          v-model="data.passport_issued_at"
        ></fg-input>
      </div>
      <div class="col-12 col-md-6">
        <fg-input
          :type="`text`"
          :label="`Кем выдан паспорт`"
          :labelKey="`passport_issued`"
          v-model="data.passport_issued"
        ></fg-input>
      </div>
      <div class="col-12 col-md-6">
        <fg-input
          :type="`date`"
          :label="`Срок паспорта`"
          :labelKey="`passport_exp`"
          v-model="data.passport_exp"
        ></fg-input>
      </div>

      <div class="col-12 col-md-6">
        <fg-input
          :type="`text`"
          :label="`ПИНФЛ`"
          :labelKey="`pinfl`"
          v-model="data.pinfl"
        ></fg-input>
      </div>
      <div class="col-12 col-md-12">
        <fg-input
          :type="`text`"
          :label="`Услица`"
          :labelKey="`street`"
          v-model="data.street"
        ></fg-input>
        <fg-input
          :type="`text`"
          :label="`Номер дома`"
          :labelKey="`house`"
          v-model="data.house"
        ></fg-input>
        <fg-input
          :type="`text`"
          :label="`Квартира`"
          :labelKey="`apartment`"
          v-model="data.apartment"
        ></fg-input>
      </div>

      <div class="col-12 col-md-6">
        <fg-input
          :type="`text`"
          :label="`Имя поручителя 1`"
          :labelKey="`guarantor1_name`"
          v-model="data.guarantor1_name"
        ></fg-input>
      </div>
      <div class="col-12 col-md-6">
        <fg-input
          :type="`text`"
          :label="`Номер поручителя 1`"
          :labelKey="`guarantor1_phone`"
          v-model="data.guarantor1_phone"
        ></fg-input>
      </div>

      <div class="col-12 col-md-6">
        <fg-input
          :type="`text`"
          :label="`Имя поручителя 2`"
          :labelKey="`guarantor2_name`"
          v-model="data.guarantor2_name"
        ></fg-input>
      </div>
      <div class="col-12 col-md-6">
        <fg-input
          :type="`text`"
          :label="`Номер поручителя 2`"
          :labelKey="`guarantor2_phone`"
          v-model="data.guarantor2_phone"
        ></fg-input>
      </div>
      <div class="col-12 col-md-6">
        <fg-input
          :type="`text`"
          :label="`Имя поручителя 3`"
          :labelKey="`guarantor3_name`"
          v-model="data.guarantor3_name"
        ></fg-input>
      </div>
      <div class="col-12 col-md-6">
        <fg-input
          :type="`text`"
          :label="`Номер поручителя 3`"
          :labelKey="`guarantor3_phone`"
          v-model="data.guarantor3_phone"
        ></fg-input>
      </div>
    </div>
    <div class="install-control">
      <button @click="send" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  components: {},
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {
    this.data = {
      passport: this.order.client.passport_number.replace(/\s/g, ""),
      passport_exp: this.order.client.passport_exp,
      passport_issued_at: this.order.client.passport_issued_at,
      passport_issued: this.order.client.passport_issued,
      pinfl: this.order.client.PINFL,
      first_name: this.order.client.first_name,
      last_name: this.order.client.last_name,
      family_name: this.order.client.family_name,
      birthday: this.order.client.birthday,
      gender: this.order.client.gender == "male" ? 1 : 2,
      documentType: null,
      addressType: null,
      regionId: null,
      districtCode: null,
      address: null,
      house: null,
      apartment: null,
      guarantor1_name: "test 1",
      guarantor1_phone: "998903467899",
      guarantor2_name: "test 2",
      guarantor2_phone: "998935604715",
      guarantor3_name: "test 3",
      guarantor3_phone: "998990059734",
    };
  },
  methods: {
    send() {
      let data = {
        client: {
          name: this.data.first_name,
          surname: this.data.last_name,
          patronym: this.data.family_name,
          birth_date: this.data.birthday,
          document_serial: this.data.passport,
          pinfl: this.data.pinfl,
          gender: this.data.gender,
        },
        document: {
          serial: this.data.passport
            ? this.data.passport.substring(0, 2)
            : null,
          number: this.data.passport ? this.data.passport.substring(2) : null,
          type: this.data.documentType,
          issue_date: this.data.passport_issued_at,
          valid: this.data.passport_exp,
          issued_by: this.data.passport_issued,
        },
        addresses: [
          {
            type: this.data.addressType,
            countryId: "211",
            regionId: this.data.regionId,
            districtCode: this.data.districtCode,
            quarter: "mahalla",
            street: this.data.street,
            house: this.data.house,
            apartment: this.data.apartment,
          },
        ],
        phones: [
          {
            phone: this.data.guarantor1_phone,
            owner: this.data.guarantor1_name,
          },
          {
            phone: this.data.guarantor2_phone,
            owner: this.data.guarantor2_name,
          },
          {
            phone: this.data.guarantor3_phone,
            owner: this.data.guarantor3_name,
          },
        ],
      };

      this.updateOrder({
        clientInfo: {
          passport_exp: this.data.passport_exp,
          birthday: this.data.birthday,
          passport_issued_at: this.data.passport_issued_at,
          passport_issued: this.data.passport_issued,
          passport_exp: this.data.passport_exp,
          passport_number: this.data.passport,
          PINFL: this.data.pinfl,
        },
      });

      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}client/create`,
        method: "POST",
        data: data,
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.data) {
            this.createTransaction({
              exchange_id: response.data.data.app_id,
              pre_api_result: JSON.stringify(response.data),
              step: "client-open",
            });
            this.$emit("setStep", "client-open");
            this.$emit("input", response.data);
          }
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 500);
        });
    },
  },
  data() {
    return {
      //GENERATE DATA
      data: {},

      //DATA INFORMER
      informers: {
        documentTypes: {
          title: "Тип паспорта",
          data: [
            {
              title: "D",
              titleLang: "D",
              value: "D",
            },
            {
              title: "I",
              titleLang: "I",
              value: "I",
            },
            {
              title: "P",
              titleLang: "P",
              value: "P",
            },
          ],
        },
        addressesTypes: {
          title: "Тип адреса",
          data: [
            {
              title: "1",
              titleLang: "1",
              value: "1",
            },
            {
              title: "2",
              titleLang: "2",
              value: "2",
            },
          ],
        },
        genderTypes: {
          title: "Пол",
          data: [
            {
              title: "Мужской",
              titleLang: "men",
              value: "1",
            },
            {
              title: "Женский",
              titleLang: "women",
              value: "2",
            },
          ],
        },
      },
    };
  },
};
</script>

